var map = {
	"./1893/10_no.svg": "8436",
	"./1893/10_uk.svg": "a0a0",
	"./1893/11_no.svg": "519c",
	"./1893/11_uk.svg": "0e7c",
	"./1893/12_no.svg": "fed9",
	"./1893/12_uk.svg": "4a4d",
	"./1893/13_no.svg": "531f",
	"./1893/13_uk.svg": "a048",
	"./1893/14_no.svg": "6cfa",
	"./1893/14_uk.svg": "f357",
	"./1893/1_no.svg": "3919",
	"./1893/1_uk.svg": "a1e7",
	"./1893/2_no.svg": "0cd0",
	"./1893/2_uk.svg": "6bbc",
	"./1893/3_no.svg": "f9ef",
	"./1893/3_uk.svg": "e5af",
	"./1893/4_no.svg": "3ecd",
	"./1893/4_uk.svg": "e464",
	"./1893/5_no.svg": "2937",
	"./1893/5_uk.svg": "40cb",
	"./1893/6_no.svg": "9856",
	"./1893/6_uk.svg": "9f81",
	"./1893/7_no.svg": "9479",
	"./1893/7_uk.svg": "78f1",
	"./1893/8_no.svg": "3858",
	"./1893/8_uk.svg": "5f5c",
	"./1893/9_no.svg": "6b14",
	"./1893/9_uk.svg": "314d",
	"./1893/heading_no.svg": "f689",
	"./1893/heading_uk.svg": "a8f1",
	"./1893/intro_no.svg": "82e4",
	"./1893/intro_uk.svg": "8b22",
	"./1893/ref_no.svg": "bcd4",
	"./1893/ship.svg": "4cd2",
	"./1925/1_no.svg": "0742",
	"./1925/1_uk.svg": "f160",
	"./1925/2_no.svg": "4007",
	"./1925/2_uk.svg": "411b",
	"./1925/3_no.svg": "d92a",
	"./1925/3_uk.svg": "c664",
	"./1925/4_no.svg": "4cc8",
	"./1925/4_uk.svg": "af16",
	"./1925/5_no.svg": "1b2d",
	"./1925/5_uk.svg": "08b9",
	"./1925/6_no.svg": "bf60",
	"./1925/6_uk.svg": "4c44",
	"./1925/7_no.svg": "bf82",
	"./1925/7_uk.svg": "dd6a",
	"./1925/8_no.svg": "0ecf",
	"./1925/8_uk.svg": "7a3d",
	"./1925/heading_no.svg": "ff83",
	"./1925/heading_uk.svg": "2518",
	"./1925/intro_no.svg": "1223",
	"./1925/intro_uk.svg": "9d40",
	"./1925/ship.svg": "2a54",
	"./1949/10_no.svg": "e4b3",
	"./1949/10_uk.svg": "096c",
	"./1949/1_no.svg": "d5f2",
	"./1949/1_uk.svg": "0347",
	"./1949/2_no.svg": "aea0",
	"./1949/2_uk.svg": "b3c0",
	"./1949/3_no.svg": "52d3",
	"./1949/3_uk.svg": "02b1",
	"./1949/4_no.svg": "4ca1",
	"./1949/4_uk.svg": "ef4d",
	"./1949/5_no.svg": "2b90",
	"./1949/5_uk.svg": "d46b",
	"./1949/6_no.svg": "f9f7",
	"./1949/6_uk.svg": "6606",
	"./1949/7_no.svg": "4075",
	"./1949/7_uk.svg": "e4be",
	"./1949/8_no.svg": "f334",
	"./1949/8_uk.svg": "e87b",
	"./1949/9_no.svg": "9498",
	"./1949/9_uk.svg": "96db",
	"./1949/heading_no.svg": "d645",
	"./1949/heading_uk.svg": "535f",
	"./1949/intro_no.svg": "e3ef",
	"./1949/intro_uk.svg": "2aa8",
	"./1949/ship.svg": "6f80",
	"./1951/1_no.svg": "51a9",
	"./1951/1_uk.svg": "c1bd",
	"./1951/2_no.svg": "dfc9",
	"./1951/2_uk.svg": "2c09",
	"./1951/3_no.svg": "b821",
	"./1951/3_uk.svg": "9c60",
	"./1951/4_no.svg": "558d",
	"./1951/4_uk.svg": "b4d8",
	"./1951/heading_no.svg": "c28f",
	"./1951/heading_uk.svg": "2566",
	"./1951/intro_no.svg": "08f2",
	"./1951/intro_uk.svg": "a543",
	"./1951/ship.svg": "7e41",
	"./1954/1_no.svg": "0e53",
	"./1954/1_uk.svg": "eae6",
	"./1954/2_no.svg": "858b",
	"./1954/2_uk.svg": "766d",
	"./1954/3_no.svg": "183a",
	"./1954/3_uk.svg": "50cc",
	"./1954/4_no.svg": "e3f5",
	"./1954/4_uk.svg": "0bc6",
	"./1954/heading_no.svg": "f37b",
	"./1954/heading_uk.svg": "5d3c",
	"./1954/intro_no.svg": "f1d6",
	"./1954/intro_uk.svg": "3ddd",
	"./1954/ship.svg": "dce2",
	"./1960/1_no.svg": "daba",
	"./1960/1_uk.svg": "c83b",
	"./1960/2_no.svg": "1202",
	"./1960/2_uk.svg": "727e",
	"./1960/3_no.svg": "7a4c",
	"./1960/3_uk.svg": "c0ba",
	"./1960/4_no.svg": "7afc",
	"./1960/4_uk.svg": "d901",
	"./1960/5_no.svg": "28e0",
	"./1960/5_uk.svg": "54a1",
	"./1960/heading_no.svg": "e7a6",
	"./1960/heading_uk.svg": "1a08",
	"./1960/intro_no.svg": "1288",
	"./1960/intro_uk.svg": "38a1",
	"./1960/ship.svg": "db85",
	"./1982/10_no.svg": "c81a",
	"./1982/10_uk.svg": "f8fa",
	"./1982/11_no.svg": "0f01",
	"./1982/11_uk.svg": "865e",
	"./1982/12_no.svg": "9057",
	"./1982/12_uk.svg": "7ab3",
	"./1982/13_no.svg": "9066",
	"./1982/13_uk.svg": "99f6",
	"./1982/1_no.svg": "0127",
	"./1982/1_uk.svg": "3ec1",
	"./1982/2_no.svg": "f869",
	"./1982/2_uk.svg": "769f",
	"./1982/3_no.svg": "e9f8",
	"./1982/3_uk.svg": "97d6",
	"./1982/4_no.svg": "9f10",
	"./1982/4_uk.svg": "82f9",
	"./1982/5_no.svg": "795c",
	"./1982/5_uk.svg": "9833",
	"./1982/6_no.svg": "e007",
	"./1982/6_uk.svg": "4c82",
	"./1982/7_no.svg": "aa52",
	"./1982/7_uk.svg": "fe85",
	"./1982/8_no.svg": "bc28",
	"./1982/8_uk.svg": "cea6",
	"./1982/9_no.svg": "d2b3",
	"./1982/9_uk.svg": "8c9a",
	"./1982/heading_no.svg": "b800",
	"./1982/heading_uk.svg": "b4e8",
	"./1982/intro_no.svg": "2707",
	"./1982/intro_uk.svg": "51cb",
	"./1982/ship.svg": "d7c2",
	"./1993/10_no.svg": "0bd3",
	"./1993/10_uk.svg": "6e4d",
	"./1993/11_no.svg": "1ce9",
	"./1993/11_uk.svg": "d682",
	"./1993/12_no.svg": "1991",
	"./1993/12_uk.svg": "12e9",
	"./1993/1_no.svg": "2e4b",
	"./1993/1_uk.svg": "c36b",
	"./1993/2_no.svg": "16c3",
	"./1993/2_uk.svg": "a831",
	"./1993/3_no.svg": "bec7",
	"./1993/3_uk.svg": "809e",
	"./1993/4_no.svg": "5ee0",
	"./1993/4_uk.svg": "1671",
	"./1993/5_no.svg": "66b8",
	"./1993/5_uk.svg": "c3d3",
	"./1993/6_no.svg": "cbfb",
	"./1993/6_uk.svg": "a54c",
	"./1993/7_no.svg": "ef7a",
	"./1993/7_uk.svg": "2556",
	"./1993/8_no.svg": "a36e",
	"./1993/8_uk.svg": "35b9",
	"./1993/9_no.svg": "4951",
	"./1993/9_uk.svg": "381d",
	"./1993/heading_no.svg": "c128",
	"./1993/heading_uk.svg": "9573",
	"./1993/intro_no.svg": "e2e7",
	"./1993/intro_uk.svg": "245c",
	"./1993/ship.svg": "3245",
	"./2016/1_no.svg": "d333",
	"./2016/1_uk.svg": "4b29",
	"./2016/2_no.svg": "d489",
	"./2016/2_uk.svg": "d02f",
	"./2016/3_no.svg": "f80a",
	"./2016/3_uk.svg": "3bd8",
	"./2016/4_no.svg": "780c",
	"./2016/4_uk.svg": "5566",
	"./2016/5_no.svg": "20ae",
	"./2016/5_uk.svg": "ba56",
	"./2016/6_no.svg": "10c3",
	"./2016/6_uk.svg": "2da0",
	"./2016/7_no.svg": "9441",
	"./2016/7_uk.svg": "aba2",
	"./2016/heading_no.svg": "960e",
	"./2016/heading_uk.svg": "1363",
	"./2016/intro_no.svg": "426d",
	"./2016/intro_uk.svg": "c7d5",
	"./2016/ship.svg": "ee5d",
	"./gui/arrow_backward.svg": "03be",
	"./gui/arrow_disabled.svg": "2b00",
	"./gui/arrow_down.svg": "b257",
	"./gui/arrow_forward.svg": "ffb3",
	"./gui/arrow_up.svg": "261d",
	"./gui/background.svg": "ad30",
	"./gui/background_line.svg": "46dd",
	"./gui/button_home.svg": "810c",
	"./gui/button_language_no.svg": "6913",
	"./gui/button_language_uk.svg": "74a5",
	"./gui/close.svg": "7f06",
	"./gui/line.svg": "6e72",
	"./gui/triangle.svg": "3d45",
	"./main/1893_no.svg": "c5b4",
	"./main/1893_uk.svg": "ac79",
	"./main/1925_no.svg": "a73b",
	"./main/1925_uk.svg": "a1d2",
	"./main/1949_no.svg": "121e",
	"./main/1949_uk.svg": "bde3",
	"./main/1951_no.svg": "4a8d",
	"./main/1951_uk.svg": "2986",
	"./main/1954_no.svg": "6e1b",
	"./main/1954_uk.svg": "cccf",
	"./main/1960_no.svg": "2aa3",
	"./main/1960_uk.svg": "cd34",
	"./main/1982_no.svg": "360b",
	"./main/1982_uk.svg": "6711",
	"./main/1993_no.svg": "b36a",
	"./main/1993_uk.svg": "4ee8",
	"./main/2016_no.svg": "8114",
	"./main/2016_uk.svg": "0864",
	"./main/Group 242.svg": "9ced",
	"./main/intro text_no.svg": "c549",
	"./main/intro text_uk.svg": "9973",
	"./originals/1893/10_no.svg": "3fda",
	"./originals/1893/10_uk.svg": "c906",
	"./originals/1893/11_l_no.svg": "5e0f",
	"./originals/1893/11_l_uk.svg": "fb18",
	"./originals/1893/12_l_no.svg": "3d56",
	"./originals/1893/12_l_uk.svg": "af90",
	"./originals/1893/13_l_no.svg": "22f9",
	"./originals/1893/13_l_uk.svg": "75d5",
	"./originals/1893/14_l_no.svg": "584d",
	"./originals/1893/14_l_uk.svg": "dee7",
	"./originals/1893/1_no.svg": "1424",
	"./originals/1893/1_uk.svg": "f04a",
	"./originals/1893/2_no.svg": "057d",
	"./originals/1893/2_uk.svg": "f611",
	"./originals/1893/3_no.svg": "99bf",
	"./originals/1893/3_uk.svg": "80c6",
	"./originals/1893/4_no.svg": "7502",
	"./originals/1893/4_uk.svg": "20f1",
	"./originals/1893/5_no.svg": "7f85",
	"./originals/1893/5_uk.svg": "8e01",
	"./originals/1893/6_no.svg": "a2e6",
	"./originals/1893/6_uk.svg": "f3d8",
	"./originals/1893/7_no.svg": "2abb",
	"./originals/1893/7_uk.svg": "c814",
	"./originals/1893/8_h_no.svg": "5258",
	"./originals/1893/8_h_uk.svg": "a0f9",
	"./originals/1893/9_no.svg": "6770",
	"./originals/1893/9_uk.svg": "d53a",
	"./originals/1893/heading_no.svg": "fc6e",
	"./originals/1893/heading_uk.svg": "f41d",
	"./originals/1893/intro_no.svg": "8280",
	"./originals/1893/intro_uk.svg": "fcc9",
	"./originals/1893/ref_no.svg": "ded9",
	"./originals/1893/ship.svg": "6c69",
	"./originals/1925/1_no.svg": "e994",
	"./originals/1925/1_uk.svg": "59fd",
	"./originals/1925/2_no.svg": "6c48",
	"./originals/1925/2_uk.svg": "860b",
	"./originals/1925/3_no.svg": "d509",
	"./originals/1925/3_uk.svg": "42fc",
	"./originals/1925/4_no.svg": "94fa",
	"./originals/1925/4_uk.svg": "f902",
	"./originals/1925/5_h_no.svg": "4d56",
	"./originals/1925/5_h_uk.svg": "a830",
	"./originals/1925/6_no.svg": "1ce7",
	"./originals/1925/6_uk.svg": "33ef",
	"./originals/1925/7_no.svg": "505b",
	"./originals/1925/7_uk.svg": "ccbb",
	"./originals/1925/8_l_no.svg": "ddc5",
	"./originals/1925/8_l_uk.svg": "dcda",
	"./originals/1925/heading_no.svg": "b577",
	"./originals/1925/heading_uk.svg": "4009",
	"./originals/1925/intro_no.svg": "4fdb",
	"./originals/1925/intro_uk.svg": "5d29",
	"./originals/1925/ship.svg": "149e",
	"./originals/1949/10_l_no.svg": "36b7",
	"./originals/1949/10_l_uk.svg": "4a9d",
	"./originals/1949/1_no.svg": "70fa",
	"./originals/1949/1_uk.svg": "5c96",
	"./originals/1949/2_h_no.svg": "38e0",
	"./originals/1949/2_h_uk.svg": "2edb",
	"./originals/1949/3_no.svg": "1420",
	"./originals/1949/3_uk.svg": "c9bd",
	"./originals/1949/4_no.svg": "889e",
	"./originals/1949/4_uk.svg": "c95f",
	"./originals/1949/5_no.svg": "9547",
	"./originals/1949/5_uk.svg": "6909",
	"./originals/1949/6_no.svg": "3e92",
	"./originals/1949/6_uk.svg": "6c81",
	"./originals/1949/7_no.svg": "7104",
	"./originals/1949/7_uk.svg": "46d9",
	"./originals/1949/8_l_no.svg": "8578",
	"./originals/1949/8_l_uk.svg": "5aef",
	"./originals/1949/9_l_no.svg": "5696",
	"./originals/1949/9_l_uk.svg": "4cf4",
	"./originals/1949/heading_no.svg": "39d8",
	"./originals/1949/heading_uk.svg": "cb3c",
	"./originals/1949/intro_no.svg": "eba7",
	"./originals/1949/intro_uk.svg": "e2d5",
	"./originals/1949/ship.svg": "380d",
	"./originals/1951/1.svg": "3fe3",
	"./originals/1951/1_uk.svg": "594a",
	"./originals/1951/2.svg": "37ac",
	"./originals/1951/2_uk.svg": "5690",
	"./originals/1951/3.svg": "9a8a",
	"./originals/1951/3_uk.svg": "539c",
	"./originals/1951/4_l.svg": "f5bd",
	"./originals/1951/4_l_uk.svg": "3ece",
	"./originals/1951/heading.svg": "9921",
	"./originals/1951/heading_uk.svg": "a859",
	"./originals/1951/intro.svg": "879a",
	"./originals/1951/intro_uk.svg": "4955",
	"./originals/1951/ship.svg": "0274",
	"./originals/1954/1_no.svg": "6e5a",
	"./originals/1954/1_uk.svg": "e5a8",
	"./originals/1954/2_h_no.svg": "8de1",
	"./originals/1954/2_h_uk.svg": "f99e",
	"./originals/1954/3_l_no.svg": "9ac1",
	"./originals/1954/3_l_uk.svg": "7cfc",
	"./originals/1954/4_l_no.svg": "1f83",
	"./originals/1954/4_l_uk.svg": "7cd9",
	"./originals/1954/heading_no.svg": "f7c5",
	"./originals/1954/heading_uk.svg": "eae2",
	"./originals/1954/intro_no.svg": "4dd7",
	"./originals/1954/intro_uk.svg": "3f21",
	"./originals/1954/ship.svg": "4b16",
	"./originals/1960/1_no.svg": "6167",
	"./originals/1960/1_uk.svg": "fae1",
	"./originals/1960/2_no.svg": "adbf",
	"./originals/1960/2_uk.svg": "5b52",
	"./originals/1960/3_h_no.svg": "2b2d",
	"./originals/1960/3_h_uk.svg": "a897",
	"./originals/1960/4_no.svg": "6d28",
	"./originals/1960/4_uk.svg": "31c9",
	"./originals/1960/5_no.svg": "28c8",
	"./originals/1960/5_uk.svg": "8f54",
	"./originals/1960/heading_no.svg": "373a",
	"./originals/1960/heading_uk.svg": "61ae",
	"./originals/1960/intro_no.svg": "2e6f",
	"./originals/1960/intro_uk.svg": "d769",
	"./originals/1960/ship.svg": "6530",
	"./originals/1982/10_no.svg": "b7d6",
	"./originals/1982/10_uk.svg": "4378",
	"./originals/1982/11_l_no.svg": "8a91",
	"./originals/1982/11_l_uk.svg": "64a4",
	"./originals/1982/12_l_no.svg": "c6f1",
	"./originals/1982/12_l_uk.svg": "ff0c",
	"./originals/1982/13_l_no.svg": "10e3",
	"./originals/1982/13_l_uk.svg": "4273",
	"./originals/1982/1_no.svg": "e080",
	"./originals/1982/1_uk.svg": "1b4e",
	"./originals/1982/2_h_no.svg": "0108",
	"./originals/1982/2_h_uk.svg": "71c7",
	"./originals/1982/3_no.svg": "d4c7",
	"./originals/1982/3_uk.svg": "a822",
	"./originals/1982/4_no.svg": "5680",
	"./originals/1982/4_uk.svg": "d96f",
	"./originals/1982/5_no.svg": "aa36",
	"./originals/1982/5_uk.svg": "b39a",
	"./originals/1982/6_no.svg": "2935",
	"./originals/1982/6_uk.svg": "8fa7",
	"./originals/1982/7_no.svg": "e168",
	"./originals/1982/7_uk.svg": "11e7",
	"./originals/1982/8_no.svg": "4a9c",
	"./originals/1982/8_uk.svg": "e643",
	"./originals/1982/9_no.svg": "e45e",
	"./originals/1982/9_uk.svg": "e300",
	"./originals/1982/heading_no.svg": "b716",
	"./originals/1982/heading_uk.svg": "c442",
	"./originals/1982/intro_no.svg": "d038",
	"./originals/1982/intro_uk.svg": "fb37",
	"./originals/1982/ship.svg": "d43b",
	"./originals/1993/10_no.svg": "de43",
	"./originals/1993/10_uk.svg": "ba08",
	"./originals/1993/11_no.svg": "d253",
	"./originals/1993/11_uk.svg": "6cf9",
	"./originals/1993/12_l_no.svg": "5720",
	"./originals/1993/12_l_uk.svg": "3dab",
	"./originals/1993/1_no.svg": "5524",
	"./originals/1993/1_uk.svg": "363e",
	"./originals/1993/2_no.svg": "0e69",
	"./originals/1993/2_uk.svg": "368e",
	"./originals/1993/3_h_no.svg": "d4a4",
	"./originals/1993/3_h_uk.svg": "b903",
	"./originals/1993/4_no.svg": "f0fa",
	"./originals/1993/4_uk.svg": "d705",
	"./originals/1993/5_no.svg": "c6e5",
	"./originals/1993/5_uk.svg": "d060",
	"./originals/1993/6_no.svg": "4cbc",
	"./originals/1993/6_uk.svg": "d24e",
	"./originals/1993/7_no.svg": "98e1",
	"./originals/1993/7_uk.svg": "f4a5",
	"./originals/1993/8_no.svg": "a522",
	"./originals/1993/8_uk.svg": "a587",
	"./originals/1993/9_no.svg": "5965",
	"./originals/1993/9_uk.svg": "29865",
	"./originals/1993/heading_no.svg": "3197",
	"./originals/1993/heading_uk.svg": "b458",
	"./originals/1993/intro_no.svg": "162b",
	"./originals/1993/intro_uk.svg": "b587",
	"./originals/1993/ship.svg": "3df7",
	"./originals/2016/1_no.svg": "60aa",
	"./originals/2016/1_uk.svg": "67bc",
	"./originals/2016/2_h_no.svg": "2c99",
	"./originals/2016/2_h_uk.svg": "2a56",
	"./originals/2016/3_no.svg": "30ca",
	"./originals/2016/3_uk.svg": "3d3d",
	"./originals/2016/4_no.svg": "bab2",
	"./originals/2016/4_uk.svg": "389e",
	"./originals/2016/5_no.svg": "be25",
	"./originals/2016/5_uk.svg": "ad20",
	"./originals/2016/6_h_no.svg": "8478",
	"./originals/2016/6_h_uk.svg": "5b63",
	"./originals/2016/7_no.svg": "56d0",
	"./originals/2016/7_uk.svg": "06e2",
	"./originals/2016/heading_no.svg": "5e14",
	"./originals/2016/heading_uk.svg": "2caf",
	"./originals/2016/intro_no.svg": "77f5",
	"./originals/2016/intro_uk.svg": "7385",
	"./originals/2016/ship.svg": "8192",
	"./originals/main/1893_no.svg": "e79c",
	"./originals/main/1893_uk.svg": "de6b",
	"./originals/main/1925_no.svg": "e2b3",
	"./originals/main/1925_uk.svg": "af54",
	"./originals/main/1949_no.svg": "ec6a",
	"./originals/main/1949_uk.svg": "9940",
	"./originals/main/1951_no.svg": "4799",
	"./originals/main/1951_uk.svg": "f5d7",
	"./originals/main/1954_no.svg": "f849",
	"./originals/main/1954_uk.svg": "f7bc",
	"./originals/main/1960_no.svg": "b833",
	"./originals/main/1960_uk.svg": "e582",
	"./originals/main/1982_no.svg": "ff7e",
	"./originals/main/1982_uk.svg": "0c59",
	"./originals/main/1993_no.svg": "3dee",
	"./originals/main/1993_uk.svg": "c517",
	"./originals/main/2016_no.svg": "ecce",
	"./originals/main/2016_uk.svg": "5d03",
	"./originals/main/Group 242.svg": "8cfa",
	"./originals/main/intro text_no.svg": "0c87",
	"./originals/main/intro text_uk.svg": "afa8",
	"./originals/refs/ test.svg": "0218",
	"./originals/refs/1893.svg": "9d8f",
	"./originals/refs/1925.svg": "2274",
	"./originals/refs/1949.svg": "35cb",
	"./originals/refs/1951.svg": "592f",
	"./originals/refs/1954.svg": "8019",
	"./originals/refs/1960.svg": "c16e",
	"./originals/refs/1982.svg": "d242",
	"./originals/refs/1993.svg": "a450",
	"./originals/refs/2016.svg": "862d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edbe";